<template>
    <div class="form-group">
        <label class="form-label" :for="id" :style="{ width: labelWidth }">
            <span v-if="required" style="color: #ff5a5a;">*</span>
            <span v-else style="visibility: hidden;">*</span>
            {{ label }}
        </label>
        <textarea
            :disabled="disabled"
            :style="{ width: inputWidth ,height:textareaheight,color:disabled ? '#adadad' : '#fff'}"
            v-model="internalValue"
            @input="updateValue"
            rows="4"
            cols="50"
        ></textarea>
    </div>
</template>

<script>
export default {
    name: 'textareaField',
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
        modelValue: {
            type: String,
            default: ""
        },
        label: {
            type: String,
            required: false,
        },
        required: {
            type: Boolean,
            default: false,
        },
        labelWidth: {
            type: String,
            default: '40%'
        },
        inputWidth: {
            type: String,
            default: '100%'
        },
        id: {
            type: String,
            required: true,
        },
        textareaheight:{
            type:String,
            default:'100%'
        }
    },
    data() {
        return {
            internalValue: this.modelValue, // 内部值，用于 v-model 绑定
        };
    },
    watch: {
        // 监听 modelValue 的变化，更新 internalValue
        modelValue(newVal) {
            this.internalValue = newVal;
        },
        // 监听 internalValue 的变化，通知父组件更新
        internalValue(newVal) {
            this.$emit('update:modelValue', newVal);
        }
    },
    methods: {
        updateValue(event) {
            this.internalValue = event.target.value; // 更新内部值
        }
    }
};
</script>

<style scoped>
.form-group {
    display: flex;
    align-items: center;
    width: 100%;
}

.form-label {
    display: block;
    color: #94a3b8;
    font-size: 0.9rem;
    width: 40%;
    white-space: nowrap;
    margin-right: 0.5rem;
}

textarea {
    border: 1px solid rgba(0, 255, 150, 0.2);
    border-radius: 5px;
    background: rgb(14, 27, 52);
    padding: 1rem;
    color: #fff;
}
</style>